"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffsTableColumn = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
const _1 = require(".");
const TariffsTableColumn = (props) => {
    const { cells, isLabel } = props;
    return (react_1.default.createElement("div", { className: `${_1.className}__column` }, cells.map((cell, i) => {
        const { content, tariff } = cell;
        const cellClassNames = (0, classFunctions_1.getClassNames)(`${_1.className}__cell`, [
            tariff ? `color-${tariff}` : undefined,
            isLabel ? 'label' : undefined,
            i === 0 ? 'header' : undefined,
        ]);
        return (react_1.default.createElement("div", { className: `${_1.className}__cell-container`, key: i },
            react_1.default.createElement("div", { className: cellClassNames }, content)));
    })));
};
exports.TariffsTableColumn = TariffsTableColumn;
//# sourceMappingURL=Column.js.map